package com.merkost.handpass.admin.platform

import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.launch
import org.w3c.dom.events.Event
import org.w3c.dom.events.EventListener

private val IS_BROWSER: Boolean =
    js("typeof window !== 'undefined' && typeof window.addEventListener === 'function'").unsafeCast<Boolean>()

class WindowFocusTrigger {
    private val _ticks = MutableSharedFlow<Long>(replay = 1)
    val ticks: SharedFlow<Long> = _ticks.asSharedFlow()

    private val scope = CoroutineScope(Dispatchers.Default)
    private var hasFocus: Boolean = if (IS_BROWSER) !window.document.asDynamic().hidden.unsafeCast<Boolean>() else false

    init {
        _ticks.tryEmit(0L)
        if (IS_BROWSER) {
            window.addEventListener("focus", EventListener { onFocus() })
            window.addEventListener("blur", EventListener { onBlur() })
            scope.launch {
                while (true) {
                    delay(30_000)
                    if (hasFocus) _ticks.tryEmit(currentTimeMillis())
                }
            }
        }
    }

    private fun onFocus() {
        hasFocus = true
        _ticks.tryEmit(currentTimeMillis())
    }

    private fun onBlur() {
        hasFocus = false
    }

    private fun currentTimeMillis(): Long = if (IS_BROWSER) window.performance.now().toLong() else 0L
}
